import type { FromBaseRow } from './from-base-context';
import { readInventoryField } from './inventory-raw-readers';

/** Index the held saved rows, including rows already mutated by another facet. */
export function inventoryChildIds(rows: Iterable<FromBaseRow>): Map<string, string[]> {
    const children = new Map<string, string[]>();
    for (const node of rows) {
        const id = String(readInventoryField(node, 'inventory_id') ?? '').toUpperCase();
        const parent = String(readInventoryField(node, 'possess_id') ?? '').toUpperCase();
        if (!id) continue;
        const siblings = children.get(parent) ?? [];
        siblings.push(id); children.set(parent, siblings);
    }
    return children;
}

/** A flat saved inventory contains only chains that still reach this holder. */
export function inventoryClosureIds(children: ReadonlyMap<string, readonly string[]>, owner: string,
    removed: ReadonlySet<string> = new Set()): Set<string> {
    const seen = new Set<string>();
    let wave = [owner.toUpperCase()];
    while (wave.length) {
        const next = wave.flatMap(parent => children.get(parent) ?? [])
            .filter(id => !removed.has(id) && !seen.has(id)).sort();
        for (const id of next) seen.add(id);
        wave = next;
    }
    return seen;
}
